import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api.js";
import Pagination from "../../../../components/Pagination/Pagination.jsx"; // Import the Pagination component

const ManageCohorts = ({ uid }) => {
  const [cohorts, setCohorts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cohortsPerPage] = useState(10);
  
  //  const [branchMapping,setBranch]=useState([])// Number of cohorts per page
  const branchMapping = {
    1: "COMPUTER",
    2: "IT",
    3: "AIDS",
    4: "AIML",
    5: "MECATRONICS",
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        // setLoading(true);
        const res1 = await api.get(`/api/branch/show`);
     
        // setBranch(res1.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Fetch cohorts from API
  useEffect(() => {
    const fetchCohorts = async () => {
      try {
        const response = await api.get(`/api/cohorts/show/${uid}`);
        setCohorts(response.data);
      } catch (error) {
        console.error("Error fetching cohorts:", error);
      }
    };
    fetchCohorts();
  }, [uid]);

  // Handle delete cohort
  const handleDelete = async (cohortId) => {
    try {
      await api.delete(`/api/cohorts/${cohortId}`);
      setCohorts(cohorts.filter((cohort) => cohort.cohort_id !== cohortId));
    } catch (error) {
      console.error("Error deleting cohort:", error);
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(cohorts.length / cohortsPerPage);

  // Get current page data
  const indexOfLastCohort = currentPage * cohortsPerPage;
  const indexOfFirstCohort = indexOfLastCohort - cohortsPerPage;
  const currentCohorts = cohorts.slice(indexOfFirstCohort, indexOfLastCohort);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="left-0 z-45 w-full mt-8">
      <div className="container mx-auto p-4">
        <h2 className="text-2xl font-bold mb-4">Manage Cohorts</h2>

        {/* Add horizontal scrollbar */}
        <div style={{ overflowX: "auto" }}>
          <table className="table-auto w-full min-w-[500px] md:min-w-[700px] lg:min-w-[900px] xl:min-w-[1200px] border-collapse">
            <thead>
              <tr>
                <th className="px-4 py-2">Cohort Name</th>
                <th className="px-4 py-2">Branch</th>
                <th className="px-4 py-2">Semester</th>
                <th className="px-4 py-2">Class Name</th>
                <th className="px-4 py-2">Academic Year</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentCohorts.map((cohort) => (
                <tr key={cohort.cohort_id}>
                  <td className="border px-4 py-2">{cohort.cohort_name}</td>
                  <td className="border px-4 py-2">
                   {cohort.bname || "Unknown Branch"}
                  </td>
                  <td className="border px-4 py-2">{cohort.semester}</td>
                  <td className="border px-4 py-2">{cohort.classname}</td>
                  <td className="border px-4 py-2">{cohort.academic_year}</td>
                  <td className="border px-4 py-2 ">
                    <div className="flex items-center justify-center">
                    {/* Edit Button */}
                    <Link
                      to={`/lms/editcohort/${cohort.cohort_id}`}
                      className="flex items-center text-blue-500 hover:text-blue-600 transition-all duration-300"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 2.293a1 1 0 0 1 1.414 1.414l-12 12a1 1 0 0 1-.293.22l-4 2a1 1 0 0 1-.707-.707l2-4a1 1 0 0 1 .22-.293l12-12a1 1 0 0 1 0-1.414zM14.121 5l2.828 2.828-8.485 8.485-2.828-2.828L14.121 5z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="ml-1">Edit</span>
                    </Link>

                    {/* Manage Students Button */}
                    <Link
                      to={`/lms/ManageStudents/${cohort.cohort_id}`}
                      className="flex items-center text-green-500 hover:text-green-600 transition-all duration-300"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-6 h-6"
                      >
                        <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-8 8a8 8 0 1 1 16 0H4z" />
                      </svg>
                      <span className="ml-1">Students</span>
                    </Link>

                    {/* Delete Button */}
                    <button
                      onClick={() => handleDelete(cohort.cohort_id)}
                      className="flex items-center text-red-500 hover:text-red-600 transition-all duration-300"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          fillRule="evenodd"
                          d="M6.707 5.293a1 1 0 0 1 1.414 0L12 9.172l3.879-3.879a1 1 0 1 1 1.414 1.414L13.414 10.586l3.879 3.879a1 1 0 0 1-1.414 1.414L12 12.828l-3.879 3.879a1 1 0 1 1-1.414-1.414l3.879-3.879L6.707 6.707a1 1 0 0 1 0-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="ml-1">Delete</span>
                    </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Component */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default ManageCohorts;
